// src/components/Pages/StatusPage.jsx
import React, { useMemo, useState, useEffect } from 'react';
import ToggleSwitch from '../UI/ToggleSwitch';
import { ELEVATOR_STATUS_OVERRIDES } from '../../config';
import parse from 'html-react-parser';

const FormattedNextStopDate = ({ date, evStatus }) => {
  // 停止予定の終了時刻を過ぎたかどうかをリアルタイムで監視
  const [isPast, setIsPast] = useState(false);

  useEffect(() => {
    if (!date || date.result !== "1") {
      setIsPast(false);
      return;
    }

    const checkTime = () => {
      const { endyear, endmonth, enddate, endhour, endminute } = date;
      // JST (UTC+9) での終了時刻を UTC ミリ秒に変換して比較
      const endUtcMs = Date.UTC(
        Number(endyear), Number(endmonth) - 1, Number(enddate),
        Number(endhour) - 9, Number(endminute)
      );
      setIsPast(Date.now() >= endUtcMs);
    };

    checkTime();
    const interval = setInterval(checkTime, 60_000); // 1分ごとにチェック
    return () => clearInterval(interval);
  }, [date]);

  if (!date || date.result !== "1" || evStatus === "3" || isPast) {
    return (
      <div>
        <div className="text-xl font-bold text-gray-800 my-2 text-start">---</div>
        <div className='border-t-2 '></div>
      </div>
    );
  }
  const { startyear, startmonth, startdate, starthour, startminute, endhour, endminute } = date;
  // 曜日の取得
  const d = new Date(startyear, startmonth - 1, startdate);
  const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
  const weekdayStr = weekdays[d.getDay()];
  // 開始時刻と終了時刻のフォーマット
  const startTime = `${starthour}:${startminute}`;
  const endTime = `${endhour}:${endminute}`;

  return (
    <div>
      <div className="text-2xl font-bold text-gray-800 my-2 text-start leading-none">
        {startyear}<span className="text-lg">年</span>
        {startmonth}<span className="text-lg">月</span>
        {startdate}<span className="text-lg">日</span>
        (<span className="text-xl">{weekdayStr}</span>)
        <br />
        {startTime} ～ {endTime}
      </div>
      <div className="border-t-2 text-sm ux-text-asterisk text-start leading-tight whitespace-pre-line">
        <p className="mt-2">{'※作業が終了する時間は前後する場合があります。あらかじめご了承ください。'}</p>
      </div>
    </div>
  );
};

const StatusPage = ({
  currentElevatorData,
  notificationEnabled,
  onToggleNotification
}) => {
  const statusOverrides = useMemo(() => {
    const statusKey = currentElevatorData?.status;
    return statusKey ? ELEVATOR_STATUS_OVERRIDES[statusKey] : ELEVATOR_STATUS_OVERRIDES['99'];
  }, [currentElevatorData?.status]);

  return (
    <div className="w-full swiper-slide-rd">
      <div className="w-full rounded-2xl flex flex-col relative">
        {/* Content Area - MainPageのFloor Selection Areaと同じ高さでスクロール可能 */}
        <div className="flex-grow h-[calc(100svh/45*36)] overflow-y-auto">
          <div className="space-y-4">
            {/* Status Card */}
            <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 max-h-[calc(100svh/45*17)]">
              <p className="text-xs text-gray-500 mb-1 text-start">運行状況</p>
              <h3 className="text-xl font-bold text-gray-800 my-2 text-start">
                {statusOverrides?.status?.title || '情報なし'}
              </h3>
              <p className="border-t-2 text-gray-600 text-sm pt-2 leading-tight text-start whitespace-pre-line">
                {parse(statusOverrides?.status?.message || '-')}
              </p>
            </div>

            {/* Schedule Card */}
            <div className="bg-white rounded-2xl shadow-lg px-6 pt-6 border border-gray-100">
              <p className="text-xs text-gray-500 mb-1 text-start">次回停止予定日</p>
              <FormattedNextStopDate date={currentElevatorData?.nextStopDate} evStatus={currentElevatorData?.status} />

              {/* 変更通知トグルスイッチ */}
              <div className="mt-6 mb-3 flex justify-end items-center">
                <div>
                  <span className="mr-6 text-sm font-semibold text-gray-700">変更通知</span>
                </div>
                <ToggleSwitch
                  checked={statusOverrides === ELEVATOR_STATUS_OVERRIDES['99'] ? false : notificationEnabled}
                  onChange={onToggleNotification}
                  disabled={statusOverrides === ELEVATOR_STATUS_OVERRIDES['99'] ? true : false}
                  size="large"
                  className="w-18"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusPage;